/* global axios */
import ApiClient from '../ApiClient';

const disconnectedUntil = new Map();

export const isCalendarDisconnected = accountId =>
  (disconnectedUntil.get(accountId) || 0) > Date.now();

export const rememberDisconnectedCalendar = accountId =>
  disconnectedUntil.set(accountId, Date.now() + 5 * 60 * 1000);

class GoogleClient extends ApiClient {
  constructor() {
    super('google', { accountScoped: true });
  }

  generateCalendarAuthorization() {
    return axios.post(`${this.url}/calendar_authorization`);
  }

  fetchCalendarEvents(params = {}) {
    return axios.get(`${this.url}/calendars`, { params });
  }
}

export default new GoogleClient();
